// import exceptions
import Exception404 from "./exceptions/Exception404";
import Exception500 from "./exceptions/Exception500";

// import Logger
import logger from './logger'

// import Axios
import Axios from 'axios';

// instantiate axios
const axios = Axios.create();
const hostname = process.env.VUE_APP_ENDPOINT_SERVICES_BOOKING;
const secure = process.env.VUE_APP_HTTP_SECURE === "true" ? "https://" : "http://";

axios.getHotel = () => {
  // isolate hotel slug
  let slug = window.location.hostname.split('.').shift();

  // localhost
  if (slug === 'localhost')
    slug = 'hotel-graffiti';

  // setup query endpoint
  let url = "/api/statics/hotel-slug/";
  let endpoint = secure + hostname + url + slug + '?pos=mementobookings';

  // make request
  return axios.get(endpoint)
    .then(response => {
      return response.data;
    })
    .catch(error => {
      logger.error(error.message, error.stack).then(() => null);
      if (error.response.status === 404) throw new Exception404();
      if (error.response.status === 500) throw new Exception500();
    });
};

axios.getAvailability = (hotel, query = null) => {

  let params = null;

  if (query) {

    let occupancies = [];
    query.rooms.forEach(room => {
      let occupancy = '';
      room.adults.forEach(adult => {
        occupancy = occupancy.concat(adult.age.toString(), ',')
      });
      room.children.forEach(child => {
        occupancy = occupancy.concat(child.age.toString(), ',')
      });
      occupancies.push(occupancy.replace(/(^\s*,)|(,\s*$)/g, ''));
    });

    params = {
      check_in: query.check_in,
      check_out: query.check_out,
      occupancies: occupancies,
      currency: query.currency,
      language: 'RO'
    };
  }

  // setup query endpoint
  let url = "/api/search/hotels/";
  let endpoint = secure + hostname + url + hotel.id;

  // setup query options
  let options = {
    params: params
  };

  // make request
  return axios.get(endpoint, options)
    .then(response => {
      response.data.check_in = query.check_in;
      response.data.check_out = query.check_out;
      response.data.currency = query.currency;
      response.data.adults = f(query.rooms);
      response.data.children = g(query.rooms);
      return response.data
    })
    .catch(error => {
      logger.error(error.message, error.stack).then(() => null);
      if (error.response.status === 404) throw new Exception404();
      if (error.response.status === 500) throw new Exception500();
    });
};

axios.getTranslations = () => {

  // hostname
  const hostname = process.env.VUE_APP_ENDPOINT_SERVICES_PROXY;

  // setup query endpoint
  let url = "/api/services-new/translations/identifiers/all/hello-romania.json";
  let endpoint = secure + hostname + url;

  // make request
  return axios.get(endpoint)
    .then(response => {
      return response.data;
    })
    .catch(error => {
      logger.error(error.message, error.stack).then(() => null);
    });
};

function f(rooms) {
  let adults = 0;
  rooms.forEach(room => {
    room.adults.forEach(() => {
      adults++;
    });
  });

  return adults;
}

function g(rooms) {
  let children = [];
  rooms.forEach(room => {
    room.children.forEach((child) => {
      children.push(child.age);
    });
  });

  return children;
}

export default axios;
